import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { component } from 'hoc'
import cn from 'classnames'
import { Button as ButtonAntd } from 'antd'
import Tooltip from 'components/tooltip'
import styles from './button.styles'

const Button = ({
  className,
  classes,
  tooltip,
  tooltipPlacement,
  ...props
}) => (
  <Fragment>
    {!!tooltip &&
      <Tooltip title={tooltip} placement={tooltipPlacement}>
        <ButtonAntd className={cn(classes.main, className)} {...props} />
      </Tooltip>}
    { !!tooltip || <ButtonAntd className={cn(classes.main, className)} {...props} /> }
  </Fragment>
)

Button.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  tooltip: PropTypes.any,
  tooltipPlacement: PropTypes.string,
}

Button.defaultProps = {
  className: undefined,
  classes: {},
  tooltip: undefined,
  tooltipPlacement: 'top',
}

export default component({ styles })(Button)

